<template>
  <label v-focus class="switch">
    <input
      tabindex="-1"
      type="checkbox"
      :checked="isChecked"
      aria-label="Interrupteur"
      @change="toggleChecked"
    />
    <span class="slider"></span>
  </label>
</template>

<script setup>
const isChecked = defineModel("checked", { type: Boolean });

defineProps({
  size: {
    type: String,
    default: "22px",
  },
  color: {
    type: String,
    default: "var(--clr-p3)",
  },
});

const toggleChecked = () => {
  isChecked.value = !isChecked.value;
};
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
  --switch-size: v-bind(size);
  --switch-color: v-bind(color);

  position: relative;
  display: inline-block;
  width: calc(var(--switch-size) * 2);
  height: calc(var(--switch-size));
  border: 2px solid transparent;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--clr-n6);
}

.slider:before {
  position: absolute;
  content: "";
  height: calc(var(--switch-size) - 8px);
  width: calc(var(--switch-size) - 8px);
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: transform 0.1s ease;
}

input:checked + .slider {
  background-color: var(--switch-color);
}

input:focus + .slider {
  box-shadow: 0 0 1px var(--switch-color);
}

input:checked + .slider:before {
  transform: translateX(var(--switch-size));
}

/* Rounded sliders */
.slider,
.switch {
  border-radius: 10px;
}

.slider:before {
  border-radius: 50%;
}
</style>
